import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dialog, Slide, Tabs, Tab, Box, IconButton } from "@material-ui/core";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { Row, Col, Alert } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import signin from "../../assets/images/login.png";
import signup from "../../assets/images/signup.png";
import SignForm from "../../form/entry/SignInForm";
import ForgetPasswordForm from "../../form/entry/ForgetPasswordForm";
import SignUpForm from "../../form/entry/SignUpForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} {...props} timeout={{ enter: 250, exit: 250 }} />; //<Slide direction="down" ref={ref} {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabContainer(props) {
  const tabTheme = createMuiTheme({
    palette: {
      primary: {
        main: "#f47d29",
      },
      secondary: {
        main: "#253592",
      },
    },
  });
  return (
    <ThemeProvider theme={tabTheme}>
      <Tabs value={0} {...props} indicatorColor="primary" centered />
    </ThemeProvider>
  );
}

const EntryDialog = (props) => {
  const { open, type, onClose } = props;
  const [value, setValue] = useState(0);
  const [message, setMessage] = useState(undefined);
  const handleTabChangeAfterSubmit = (message) => {
    setValue(0);
    setMessage(message);
  };
  const resetFormState = (message) => {
    setValue(0);
  };

  const handleChange = (event, newValue) => {
    if (newValue === undefined) newValue = 2;
    setValue(newValue);
  };

  useEffect(() => {
    if (type === "signin") {
      setValue(0);
    }
    if (type === "signup") {
      setValue(1);
    }
  }, [type]);

  return (
    <Dialog
      test_id="signin-dialog"
      className="entry-dialog"
      open={open}
      fullWidth={true}
      maxWidth="md"
      onBackdropClick={() => onClose({ open: false, type: "signin" })}
      TransitionComponent={Transition}
      transitionDuration={{ enter: 250, exit: 250 }}
    >
      <div className="header">
        <IconButton
          size="medium"
          className="close-button"
          onClick={() => onClose({ open: false, type: "signin" })}
        >
          <CloseOutlined />
        </IconButton>
      </div>
      <Row align="middle">
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <div className="entry-container">
            <div className="entry-element-container">
              {message && (
                <Alert
                  message={message.title}
                  description={message.body}
                  type={message.type ?? "success"}
                  showIcon
                  closable
                />
              )}
              <TabContainer
                centered
                value={value}
                onChange={handleChange}
                variant="standard"
              >
                {value === 2 || (
                  <Tab test_id="signin-tab" label="Sign In" {...a11yProps(0)} />
                )}
                {value === 2 || (
                  <Tab test_id="signup-tab" label="Sign Up" {...a11yProps(1)} />
                )}
              </TabContainer>
              <TabPanel value={value} index={0}>
                <SignForm
                  onChange={handleChange}
                  changeTab={handleTabChangeAfterSubmit}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <SignUpForm changeTab={handleTabChangeAfterSubmit} />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <ForgetPasswordForm
                  onChange={resetFormState}
                  changeTab={handleTabChangeAfterSubmit}
                />
              </TabPanel>
            </div>
          </div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <div className="entry-container">
            <img
              className="entry-element-container"
              src={value === 0 ? signin : signup}
              alt="entry"
            />
          </div>
        </Col>
      </Row>
    </Dialog>
  );
};

EntryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
EntryDialog.defaultProps = {
  open: false,
};

export default EntryDialog;
